import RadarChart, { IRadarChartData } from '@common/radarChart';
import { PaccJobCurationVO } from '@domain/vo/phs/pacc/competence/PaccJobCurationResultVO';
import { jobCurationResultColorMap, jobCurationResultTextMap } from '@domain/constant/jobCurationResultType';
import { fitDescTextMap, fitTextMap, FitType } from '@domain/constant/fitType';
import classnames from 'classnames/bind';
import styles from './jobRadarChart.module.scss';

const cx = classnames.bind(styles);

interface JobRadarChartProps {
  selectedJobCuration: PaccJobCurationVO | null;
}

const JobRadarChart = ({ selectedJobCuration }: JobRadarChartProps) => {
  if (!selectedJobCuration) return null;
  const { resultType, jobTitleName, fitScores, description, keyword, comment } = selectedJobCuration;

  const rankThree = fitScores.sort((a, b) => b.score - a.score).slice(0, 3);
  const getIsEmphasized = (fitType: FitType) => !!rankThree.find((e) => e.fitType === fitType);

  const radarChartData: IRadarChartData[] = fitScores.map((fitScore, i) => {
    const { score, fitType } = fitScore;
    return {
      title: fitTextMap[fitType],
      emphasized: getIsEmphasized(fitType),
      values: [score],
      tooltipTitle: fitTextMap[fitType],
      tooltipContents: fitDescTextMap[fitType],
    };
  });

  return (
    <div className={cx('chartArea')}>
      <em className={cx('recommend', jobCurationResultColorMap[resultType])}>{jobCurationResultTextMap[resultType]}</em>
      <strong className={cx('title')}>{jobTitleName}</strong>

      <div className={cx('chartWrap')}>
        <RadarChart radarChartDataList={radarChartData} />
        <span className={cx('chartDesc')}>[{jobTitleName}에 필요한 역량 중 내가 보유한 역량 분포]</span>
        <div className={cx('descArea')}>
          <strong className={cx('descTitle')}>{description}</strong>
          <span className={cx('desc')}>
            {keyword} {comment}
          </span>
        </div>
      </div>
    </div>
  );
};

export default JobRadarChart;
